import { useEffect } from 'react';
import { ClipStore } from '../types';

interface UseCleanupParams {
  store: ClipStore;
}

export const useCleanup = ({ store }: UseCleanupParams) => {
  useEffect(() => {
    return () => {
      store.setCurrentTime(0);
      store.setIsPlaying(false);
      store.setIsFullscreen(false);
      store.setIsMuted(false);
      store.setVolume(100);
      store.setPrevVolume(100);
      store.setPreview(null);
    };
  }, [store]);
};
